import { useEffect, useMemo, useState } from "react";
import { FaBoxOpen } from "react-icons/fa";
import { Link } from "react-router-dom";
import API from "../../../utils/api";
import { filterVisibleCategories } from "../../../utils/categoryFilters";
import classes from "./Section1.module.css";

const DEFAULT_CARDS = [
  {
    name: "Networking Devices",
    desc: "Fast Reliable Connectivity.",
    bgColor: "#6cb5b0",
  },
  {
    name: "Motherboard",
    desc: "Essential System Hub.",
    bgColor: "#6cb5b0",
  },
  {
    name: "SSD",
    desc: "High-Speed Storage.",
    bgColor: "#6cb5b0",
  },
  {
    name: "Storage Device",
    desc: "Secure Data Backup.",
    bgColor: "#6cb5b0",
  },
  {
    name: "Graphics Card",
    desc: "Powerful Visual Performance.",
    bgColor: "#6cb5b0",
  },
];

export default function Section1() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true); // loading state

  useEffect(() => {
    async function fetchCategories() {
      setLoading(true);
      try {
        const response = await API.post("/categories.php", { action: "fetch" });
        const payload = Array.isArray(response.data)
          ? response.data
          : response.data?.data || [];
        const visible = filterVisibleCategories(payload).slice(0, 5);
        setCategories(visible);
      } catch (err) {
        console.error("Failed to load categories:", err);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    }
    fetchCategories();
  }, []);

  const cards = useMemo(() => {
    const sourceCards = categories.length ? categories : DEFAULT_CARDS;

    return sourceCards.slice(0, 5).map((item, index) => {
      return {
        ...DEFAULT_CARDS[index],
        name: item.categoryName || DEFAULT_CARDS[index].name,
        desc: item.description || DEFAULT_CARDS[index].desc,
        link: item.category_slug ? `/category/${item.category_slug}` : "/shop",
        linkText: `View ${item.categoryName || "Products"}`,
        bgColor: DEFAULT_CARDS[index].bgColor,
        image: DEFAULT_CARDS[index].image,
      };
    });
  }, [categories]);

  // if (loading) {
  //   return <LoaderComp />;
  // }

  return (
    <div className={classes.section1Wrapper}>
      <div className={classes.section1Container}>
        <h2>Shop By Category</h2>
        <div className={classes.section1ContentMain}>
          {cards.map((item, idx) => (
            <div
              className={classes.section1Content}
              style={{ backgroundColor: `${item.bgColor}` }}
              key={`${item.name}-${idx}`}
            >
              <div className={classes.section1Heading}>
                <h3>{item.name}</h3>
                <p>{item.desc}</p>
                <Link to={item.link}>View Category</Link>
              </div>
              <div className={classes.section1Image}>
                <FaBoxOpen />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
